export type User = {
  id: number;
  first_name: string;
  last_name?: string;
  email: string;
  phone?: string;
  address?: string;
  zip_code?: string;
  city?: string;
  active: boolean;
  actor_type: number;
  country_id: number;
  state_id: number;
  roles?: {
    id: number;
    name: string;
  }[];
};

export type UserResponse = {
  user?: User;
  token?: string;
};

export type UserRoles = Record<string, number>;

export enum UserRole {
  SuperAdmin = 1,
  Doctor = 2,
  Patient = 3,
  Nurse = 4,
  Admin = 5,
  // also called nurse manager
  Manager = 6,
  Supplier = 7,
  PtxSupportPartner = 8,
  PrivacyModerator = 9,
  PTXTraining = 10,
  SupportNameChangerAdmin = 11,
  SupportMedicalRecordsConsentSenderAdmin = 12,
  SupportInstantDoctorConsultationCreatorAdmin = 13,
}

// Roles that add a capability without replacing a user's existing access,
// vs a full role transition. Actor permissions are kept only if ALL granted roles are additive.
// TODO: FE and BE duplicating this - needs to be done properly (techdebt)
export const AdditiveUserRoles: Record<UserRole, boolean> = {
  [UserRole.SuperAdmin]: false,
  [UserRole.Doctor]: false,
  [UserRole.Patient]: false,
  [UserRole.Nurse]: false,
  [UserRole.Admin]: false,
  [UserRole.Manager]: false,
  [UserRole.Supplier]: false,
  [UserRole.PtxSupportPartner]: false,
  [UserRole.PTXTraining]: false,
  [UserRole.PrivacyModerator]: true,
  [UserRole.SupportNameChangerAdmin]: true,
  [UserRole.SupportMedicalRecordsConsentSenderAdmin]: true,
  [UserRole.SupportInstantDoctorConsultationCreatorAdmin]: true,
};

export const StaffRoleIds: UserRole[] = [
  UserRole.SuperAdmin,
  UserRole.Doctor,
  UserRole.Nurse,
  UserRole.Admin,
  UserRole.Manager,
  UserRole.PtxSupportPartner,
  UserRole.PrivacyModerator,
];

export type ValidLoginRoles = [
  UserRole.SuperAdmin,
  UserRole.Doctor,
  UserRole.Nurse,
  UserRole.Admin,
  UserRole.Manager,
  UserRole.PtxSupportPartner,
  UserRole.PrivacyModerator,
];
